import { render, staticRenderFns } from "./nav-drawer-profile-actions-container.vue?vue&type=template&id=48d57ff4&scoped=true&"
import script from "./nav-drawer-profile-actions-container.vue?vue&type=script&lang=js&"
export * from "./nav-drawer-profile-actions-container.vue?vue&type=script&lang=js&"
import style0 from "./nav-drawer-profile-actions-container.vue?vue&type=style&index=0&id=48d57ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d57ff4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
